module.exports = __webpack_public_path__ + "static/media/spectralLogo.98770a4e.jpeg";